<div class="loader {className}"></div>

<script>
	let className = '';

	export { className as class };
</script>

<style lang="scss">
.loader {
	width: 1em;
	height: 1em;
	box-sizing: border-box;
	border: 3px solid rgba(white, 0.2);
	border-top: 3px solid white;
	border-radius: 50%;
	animation: spin 1s linear infinite;
}
@keyframes spin {
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
}
</style>